import OfferTilePricing from 'components/OfferList/OfferListTiles/Support/OfferTilePricing'
import useOfferMetaData from 'hooks/Offers/useOfferMetaData'
import { isDisplayablePrice } from 'lib/offer/pricingVisibility'
import type { LEOfferPricingComponentProps } from '../LEOfferPriceDetails'

function LEOfferStreamPricing({ offer, filters }: LEOfferPricingComponentProps) {
  const metadata = useOfferMetaData(offer.id, filters)
  const pkg = offer.lowestPricePackage

  if (!pkg || metadata?.available !== true || metadata.hidePricing || !isDisplayablePrice(metadata.pricing?.lowestPrice)) {
    return null
  }

  return <OfferTilePricing
    offer={offer}
    pkg={pkg}
    filters={filters}
    hasDates
    duration={metadata.pricing.duration}
    align="start"
  />
}

export default LEOfferStreamPricing
